import React, { useState } from "react";
import { useNotaire } from "../../context/NotaireContext";
import { Fieldset, Legend } from "../../components/catalyst/fieldset";
import { toast } from "react-toastify";
import { CheckIcon } from "@heroicons/react/20/solid";

const SPECIALITE_LIST = [
  "Immobilier",
  "Succession / Donation",
  "Fiscalité & gestion de patrimoine",
  "Droit de l'entreprise",
  "Droit de la famille",
  "Institutionnel",
];

function PanelSpecialites() {
  const context = useNotaire();
  const [specialites, setSpecialites] = useState(
    context.infoNotaire.specialites || []
  );
  const [loading, setLoading] = useState(false);

  const handleCheck = (event) => {
    const { value, checked } = event.target;

    setSpecialites((prev) =>
      checked ? [...prev, value] : prev.filter((val) => val !== value)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(
        `https://api.airtable.com/v0/appD48APNaGA4GN0B/info-notaire/${context.infoNotaire.id}`,
        {
          method: "PATCH",
          headers: {
            Authorization:
              "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fields: { specialites } }),
        }
      );

      if (res.ok) {
        toast.success("Spécialités mises à jour !");
      } else {
        const errText = await res.text();
        console.error("Erreur Airtable :", errText);
        toast.error("Erreur lors de la mise à jour.");
      }
    } catch (err) {
      console.error("Erreur réseau :", err);
      toast.error("Erreur réseau");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow mt-8">
      <Fieldset>
        <Legend>Vos spécialités</Legend>

        <p className="mt-1 text-sm text-gray-600">
          Vous pouvez mettre en avant une spécialité afin de permettre à nos
          partenaires de vous identifier plus précisément sur un domaine
          spécifique.
        </p>

        <div className="flex flex-wrap gap-2 mt-4">
          {SPECIALITE_LIST.map((spec) => {
            const isSelected = specialites.includes(spec);

            return (
              <label
                key={spec}
                className={`
                  inline-flex items-center gap-1.5
                  cursor-pointer rounded-full border px-3 py-1.5
                  text-sm font-medium transition-all duration-150
                  ${
                    isSelected
                      ? "bg-indigo-600 text-white border-indigo-600"
                      : "bg-gray-100 text-gray-700 border-gray-200 hover:bg-indigo-50 hover:border-indigo-300 hover:text-indigo-700"
                  }
                `}
              >
                <input
                  type="checkbox"
                  value={spec}
                  checked={isSelected}
                  onChange={handleCheck}
                  className="hidden"
                />

                <span
                  className={`transition-all duration-150 ${
                    isSelected ? "opacity-100 scale-100" : "opacity-0 scale-75 w-0"
                  }`}
                >
                  <CheckIcon className="h-4 w-4" />
                </span>

                <span>{spec}</span>
              </label>
            );
          })}
        </div>
      </Fieldset>

      <button type="submit" className="btn-primary mt-4" disabled={loading}>
        {loading ? "Mise à jour..." : "Modifier les spécialités"}
      </button>
    </form>
  );
}

export default PanelSpecialites;